
/**
 * 수강신청 상태
 */
export type EnrollmentInfoStatus = typeof EnrollmentInfoStatus[keyof typeof EnrollmentInfoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentInfoStatus = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  SUSPENDED: 'SUSPENDED',
  EXPIRED: 'EXPIRED',
} as const;
